import { render, staticRenderFns } from "./EditObjectTopBarIcon.vue?vue&type=template&id=27258e52&"
import script from "./EditObjectTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./EditObjectTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports